import { Component, Input, OnInit } from '@angular/core';
import { MapService } from 'src/app/services/map/map.service';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.sass'],
})
export class ToggleSwitchComponent implements OnInit {
  @Input() public selected: boolean;
  @Input() public forOthers: boolean;

  constructor(private mapService: MapService) { }

  ngOnInit(): void { }

  valueChanged({ target }): void {
    if (this.forOthers) {
       return
    }
    if (target.checked) {
      //this.mapService.addGrid({});
    } else {
      //this.mapService.removeAllGrid();
    }
  }
}
